import type {
  RuleConditionType,
  RuleFilterOperator,
} from '@/types/core/workflow-rule';

// Labels for every operator in RuleFilterOperator (which derives from the
// generated OpenAPI enum). This is a Record, not a list, so the compiler refuses
// an operator added to the engine vocabulary until it has a picker label here —
// the drift this closes is a `not_contains` rule rendering blank because the
// picker never carried it. Insertion order is picker order.
const RULE_FILTER_OPERATOR_LABELS: Record<RuleFilterOperator, string> = {
  equals: 'Equals',
  not_equals: 'Not Equals',
  contains: 'Contains',
  not_contains: 'Does Not Contain',
  starts_with: 'Starts With',
  ends_with: 'Ends With',
  greater_than: 'Greater Than',
  greater_equal: 'Greater Than Or Equal',
  less_than: 'Less Than',
  less_equal: 'Less Than Or Equal',
  in: 'In',
  not_in: 'Not In',
  matches_regex: 'Matches Regex',
  is_null: 'Is Null',
  is_not_null: 'Is Not Null',
  exists: 'Exists',
  not_exists: 'Does Not Exist',
};

export const RULE_FILTER_OPERATOR_OPTIONS: {
  value: RuleFilterOperator;
  label: string;
}[] = (Object.keys(RULE_FILTER_OPERATOR_LABELS) as RuleFilterOperator[]).map(
  (value) => ({ value, label: RULE_FILTER_OPERATOR_LABELS[value] })
);

// isRuleFilterOperator checks a wire value against the known operator set, so an
// extractor can refuse to cast an unrecognized string into the union blind.
export function isRuleFilterOperator(
  value: string | undefined
): value is RuleFilterOperator {
  return value != null && value in RULE_FILTER_OPERATOR_LABELS;
}

export const RULE_CONDITION_TYPE_OPTIONS: {
  value: RuleConditionType;
  label: string;
}[] = [
  { value: '', label: 'No condition' },
  { value: 'boolean_became_true', label: 'Boolean became true' },
  { value: 'boolean_became_false', label: 'Boolean became false' },
  { value: 'value_changed', label: 'Value changed' },
  { value: 'value_equals', label: 'Value equals' },
  { value: 'array_item_added', label: 'Array item added' },
  { value: 'array_item_removed', label: 'Array item removed' },
];
